import store from 'src/store'

export default () => {
  store.rehydrateMentions()
}
